import {
  ChangeDetectionStrategy,
  Component,
  Inject,
}                                 from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA }        from '@angular/material/dialog';
import { RbDocument }             from '~domain/types';
import {
  DialogButton,
  DialogConfig,
}                                 from '~shared/components';
import { RbDialogForm }           from '~shared/directives';
import { ValidatorService }       from '../../core/validators';
import { RenameDocumentService }  from './rename-document.service';

@Component({
  selector: 'rb-rename-document-dialog',
  templateUrl: './rename-document-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RenameDocumentDialogComponent extends RbDialogForm {
  renameDocumentIsLoading$ = this.renameDocumentService.renameDocumentIsLoading$;
  override form = this.fb.group({
    name: this.fb.control(this.document.name),
  });

  dialogConfig: DialogConfig = {
    title: 'APP.DOCUMENT.RENAME_DOCUMENT.DIALOG.TITLE',
    closeable: true,
    compact: true,
    errorKey$: this.errorKey$,
    errorContext: 'APP.DOCUMENT.RENAME_DOCUMENT.DIALOG.ERROR',
    buttons: [
      {
        id: DialogButton.Cancel,
        label: 'APP.BUTTON.CANCEL.LABEL',
        icon: 'cross',
        style: 'secondary',
      },
      {
        id: DialogButton.OK,
        label: 'APP.BUTTON.CONFIRM.LABEL',
        icon: 'check',
        style: 'primary',
        autoClose: false,
        disabled$: this.submitDisabled$,
        isLoading$: this.renameDocumentIsLoading$,
      },
    ],
  };

  constructor(
    protected override readonly fb: NonNullableFormBuilder,
    @Inject(MAT_DIALOG_DATA) public document: RbDocument,
    private readonly renameDocumentService: RenameDocumentService,
    protected override readonly validatorService: ValidatorService,
  ) {
    super(fb, validatorService);
  }

  onDialogButtonClick(dialogButton: DialogButton) {
    if (dialogButton !== DialogButton.OK || !this.form.valid) {
      return;
    }
    this.renameDocumentService.renameDocument(
      this.form.controls.name.value,
      this.document.id,
      this.document.client?.id,
    );
  }
}
